import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuizLabelOption } from 'src/app/quiz/models/quiz-question.model';
import { BaseAccessorControlComponent } from 'src/app/shared/models/base-inputs';
import { LabelModel } from 'src/app/story/models/labels/label.model';

@Component({
  selector: 'app-quiz-label',
  templateUrl: './quiz-label.component.html',
  styleUrls: ['./quiz-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuizLabelComponent),
      multi: true
    }
  ]
})
export class QuizLabelComponent extends BaseAccessorControlComponent implements OnInit {

  @Input()
  sequence = 0;

  @Input()
  collapsed: boolean;

  @Input()
  options: QuizLabelOption[];

  @Input()
  option: QuizLabelOption;

  @Input()
  correct: boolean;

  @Output()
  labelUpdated = new EventEmitter<LabelModel>();

  @Input()
  mode: 'edit' | 'summary';

  ngOnInit() {
  }

  handleLabelUpdated(event: { label: LabelModel, shouldPreserve: boolean }) {
    this.labelUpdated.next(event.label);
  }

  handleOffsetUpdated(event: {labelId: string, offset: [number, number]}) {
    this.labelUpdated.next({
      ...this.option.label,
      offset: event.offset
    });
  }

  getSelectedLabel(options: QuizLabelOption[], selectedOptionId: string): LabelModel {
    const option = this.options
      .find((value) => value.value === selectedOptionId);
    return option ? option.label : undefined;
  }
}
